import React from "react";
import { Input } from "@fluentui/react-components";
import { SearchRegular } from "@fluentui/react-icons";
import { searchBoxWrapperClass } from "./styles";

type FolderSearchBoxProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const FolderSearchBox: React.FC<FolderSearchBoxProps> = ({
  value,
  onChange,
  placeholder = "Search folders…",
}) => (
  <div className={searchBoxWrapperClass}>
    <Input
      style={{ width: "100%" }}
      contentBefore={<SearchRegular />}
      value={value}
      onChange={(_, data) => onChange(data.value)}
      placeholder={placeholder}
      aria-label="Search folders"
      autoFocus
    />
  </div>
);

export default FolderSearchBox;
